<template>
  <div>
    <div class="base-container">

      <div>
        <button class="music" @click="togglePlay" :class="playing ? 'pause' : 'play'"></button>
        <audio ref="audio" src="../assets/music/music.mp3" controls hidden autoplay preload loop="loop"></audio>
      </div>

      <!--      <div class="announcement">-->
      <!--        <div class="announcement-item" v-for="(item, index) in actionList" :key="index">-->
      <!--          {{ item.displayMsg }}-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="announcement">
        <div v-for="(item, index) in actionList" :key="index" class="announcement-item" :style="scrollStyle">
          {{ item.displayMsg }}
        </div>
      </div>

      <div v-show="showFlower" @click="showFlower = false" class="dialog">
        <div @click.stop class="dialog-content">
          <h3 style="color: white">敬献鲜花</h3>
          <div class="dialog-input-container">
            <label style="color: white" for="username">故人姓名：</label>
            <input v-model="receiver" class="underline-input" type="text">
          </div>
          <img class="flower-form-flower" src="../assets/image/flower.png" alt="">
          <button id="confirmFlower" class="submit-button" @click="submitAction('flower')">敬献</button>
        </div>
      </div>

      <div v-show="showLight" @click="showLight = false" class="dialog">
        <div @click.stop class="dialog-content">
          <h3 style="color: white">点亮烛光</h3>
          <div class="dialog-input-container">
            <label style="color: white" for="username">故人姓名：</label>
            <input v-model="receiver" class="underline-input" type="text">
          </div>
          <img class="flower-form-flower" src="../assets/image/zhuguang.png" alt="">
          <button id="confirmFlower" class="submit-button" @click="submitAction('light')">点亮</button>
        </div>
      </div>

      <div v-show="showMiss" @click="showMiss = false" class="dialog">
        <div @click.stop class="dialog-content">
          <h3 style="color: white">选择思念心情</h3>
          <div class="dialog-input-container">
            <label style="color: white" for="username">故人姓名：</label>
            <input v-model="receiver" class="underline-input" type="text">
          </div>
          <div class="list-container">
            <div class="custom-radio" v-for="(option, index) in optionMsgList" :key="index"
                 @click="selectOption(index)">
              <p :class="{active: index === selectedIndex}">{{ option }}</p>
            </div>
          </div>
          <button id="confirmFlower" class="submit-button" @click="submitAction('miss')">发表</button>
        </div>
      </div>

      <div v-show="showPost" @click="showPost = false" class="dialog">
        <div @click.stop class="dialog-content">
          <h3 style="color: white">写下您想说的话</h3>
          <div class="dialog-input-container">
            <label style="color: white" for="username">故人姓名：</label>
            <input v-model="receiver" class="underline-input" type="text">
          </div>
          <div class="textarea-container">
            <textarea class="textarea-body" placeholder="请输入想说的话" cols="64" rows="3"
                      v-model="sendMsg" maxlength="64"/>
            <span class="textarea-count">{{ sendMsg.length }}/64</span>
          </div>
          <button class="submit-button" @click="submitAction('post')">发送</button>
        </div>
      </div>

      <!--      <div class="button-container">-->
      <!--        <div id="flower" @click="clickAction('flower')">-->
      <!--          <img class="button-img" src="../assets/image/icon1.png" alt="献花">-->
      <!--        </div>-->
      <!--        <div id="light" @click="clickAction('light')">-->
      <!--          <img class="button-img" src="../assets/image/icon2.png" alt="点亮烛光">-->
      <!--        </div>-->
      <!--        <div id="post" @click="clickAction('post')">-->
      <!--          <img class="button-img" src="../assets/image/icon3.png" alt="天堂邮局">-->
      <!--        </div>-->
      <!--        <div id="express" @click="clickAction('express')">-->
      <!--          <img class="button-img" src="../assets/image/icon4.png" alt="发表哀思">-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="button-container">
        <div class="one-button" @click="clickAction('flower')">
          <img src="../assets/image/button1.png" alt="献花" class="circle-image">
          <span class="round-button">献花</span>
        </div>
        <div class="one-button" @click="clickAction('light')">
          <img src="../assets/image/button2.png" alt="点亮烛光" class="circle-image">
          <div class="round-button">点亮烛光</div>
        </div>
        <div class="one-button" @click="clickAction('miss')">
          <img src="../assets/image/button3.png" alt="发表哀思" class="circle-image">
          <div class="round-button">发表哀思</div>
        </div>
        <div class="one-button" @click="clickAction('post')">
          <img src="../assets/image/button4.png" alt="天堂邮局" class="circle-image">
          <div class="round-button">天堂邮局</div>
        </div>
      </div>

      <div class="footer">
        <span style="color: white; size: 14px">九龙生态园</span>
        <span style="color: white; text-decoration: underline; size: 12px">关注我们</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import {sendAction, getActionList, login, getWxToken} from "@/api/api"
import {getOpenId, setOpenId, setToken} from "@/utils/auth";

export default {
  name: 'HomeView',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    HelloWorld
  },
  data() {
    return {
      actionList: [],
      showFlower: false,
      showLight: false,
      showPost: false,
      showMiss: false,
      sendMsg: "",
      receiver: "",
      optionMsgList: [
        "在这广袤的宇宙中，思念如流星划破夜空，愿你在彼岸温暖如初。",
        "我的肩上是风，风上闪烁的是思念。",
        "怀念是岁月对我们的馈赠，您长眠，我常念。",
        "清明节到了，连吹来的风都是思念的味道。",
        "夜色渐深，月亮如镜，寂静的夜晚里，我开始想念，那是一种无法言说的情愫。",
        "思念是一束光，照亮了我对你的无尽牵挂。",
        "望着月亮，心里驻满思念。",
        "又是一个思亲的日子，时间并没有让我们忘记，反而让我们越记越深。",
        "我的思念，化作一个个流动的符号飘向你。",
        "你是我心中最美好的记忆。"
      ],
      selectedIndex: null,
      playing: false,
      messages: ['公告1', '公告2', '公告3', '公告4', '公告5'],
      scrollDistance: 0, // 已滚动距离
      messageHeight: 25, // 消息高度
    }
  },
  mounted() {
    this.launch();

    console.log("进入mount")


    setInterval(this.scroll, 2000); // 每2秒滚动一次

    this.getList()

  },
  beforeDestroy() {
  },
  computed: {
    augmentedMessages() {
      // 在数据列表末尾添加第一条数据的副本来实现循环
      // return [...this.messages, this.messages[this.messages.length - 1]];
      return this.messages;
    },
    scrollStyle() {
      return {
        transform: `translateY(-${this.scrollDistance}px)`,
        transition: 'transform 0.5s'
      };
    }
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
    this.getToken()
  },
  methods: {
    getList() {
      getActionList().then(res => {
        console.log(res)
        this.actionList = res.data
      })
    },
    scroll() {
      const messageCount = this.actionList.length;
      if (messageCount > 1) { // 仅当有多条消息时滚动
        // 滚动到最后一条消息后，重置为第一条消息的位置
        if (this.scrollDistance >= this.messageHeight * (messageCount - 1)) {
          // 重置滚动距离，显示最后一条数据
          this.scrollDistance = this.messageHeight * (this.messages.length - 1);
        } else {
          this.scrollDistance += this.messageHeight;
        }
      }
    },
    oauth() {
      // const appid = 'wxdd758c9cb9f778fb';
      const appid = 'wxa85db41e336bad9e';
      const callback_url = encodeURIComponent(window.location.href); // 获取当前地址，跳转至以下腾讯地址会携带code重定向到该地址
      // const callback_url = "http://139.155.3.212:8081";
      // const callback_url = "http://jl.xiaye.top";
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${callback_url}&response_type=code&scope=snsapi_userinfo&state=state1#wechat_redirect`;
    },
    getToken() {
      getWxToken().then(res => {
        console.log(res)
        setToken(res.data)
      })
    },
    launch() {
      //启动流程，有code则去后端进行登录，没code则去获取code

      if (this.isCode()) {

        console.log(this.$route.query)
        let code = this.$route.query.code
        console.log(code)

        let body = {
          code: code,
          openId: getOpenId()
        }
        login(body).then(res => {
          setToken(res.data.token)
          setOpenId(res.data.openId)
        })
      } else {
        this.oauth()
      }
    },
    isCode() {
      return window.location.search.includes('code=')
    },
    selectOption: function (index) {
      this.selectedIndex = index;
    },
    togglePlay() {
      const audio = this.$refs.audio;
      if (this.playing) {
        audio.pause();
      } else {
        audio.play();
      }
      this.playing = !this.playing;
    },
    submitAction(action) {
      if (!this.receiver) {
        this.$message.warning("请填写故人姓名");
        return
      }
      this.showMiss = false
      this.showLight = false
      this.showPost = false
      this.showFlower = false
      let body = {
        receiver: this.receiver,
        remark: "",
        type: 0,
      }

      if (action === "flower") {
        body.type = 1;
      } else if (action === "light") {
        body.type = 2;
      } else if (action === "miss") {
        body.type = 3;
        let str = this.optionMsgList[this.selectedIndex];
        console.log(str)
        body.remark = str
        console.log(body.remark)
      } else if (action === "post") {
        body.type = 4;
        body.remark = this.sendMsg
        this.sendMsg = ""
      }
      sendAction(body).then(res => {
        console.log(res)
        this.receiver = ""
        this.getList();
      })

    },
    clickAction(action) {
      if (action === "miss") {
        this.showMiss = true
        this.showLight = false
        this.showPost = false
        this.showFlower = false
      } else if (action === "flower") {
        this.showMiss = false
        this.showLight = false
        this.showPost = false
        this.showFlower = true
      } else if (action === "post") {
        this.showMiss = false
        this.showLight = false
        this.showPost = true
        this.showFlower = false
      } else if (action === "light") {
        this.showMiss = false
        this.showLight = true
        this.showPost = false
        this.showFlower = false
      }
    },
  },
}
</script>


<style lang="less">
@import "@/assets/css/index.css";

.message-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.message {
  height: 20px; /* 每条消息的高度 */
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>